'use client'

import React, { useState } from 'react'
import { AntdRegistry } from '@ant-design/nextjs-registry'
import { UserStoreProvider } from '@/stores/user-store-provider'
import { Header as ClientHeader } from '@/components/Header/client'
import SideBar from '@/components/SideBar'

interface LayoutClientProps {
  lng: string
  children: React.ReactNode
}

export default function RootLayoutClient({ lng, children }: LayoutClientProps) {
  // toggle侧边栏
  const [isSidebarOpen, setIsSidebarOpen] = useState(false)
  const toggleSidebar = () => {
    setIsSidebarOpen((prevState) => !prevState)
  }

  const closeSidebar = () => {
    setIsSidebarOpen(false)
  }

  return (
    <UserStoreProvider>
      <AntdRegistry>
        <SideBar lng={lng} isSidebarOpen={isSidebarOpen} closeSidebar={closeSidebar} />
        <div className="overflow-x-hidden flex-1">
          {/* 主区域点击遮罩 - 只在侧边栏打开时显示 */}
          {isSidebarOpen && <div className="fixed inset-0 z-[9998] cursor-pointer bg-transparent" onClick={closeSidebar} />}
          <div className={`relative z-[10] w-full bg-white pt-[81px] transition-[margin-left] duration-[400ms] ease-in-out ${isSidebarOpen ? 'ml-[290px]' : 'ml-0'}`}>
            <ClientHeader lng={lng} toggleSidebar={toggleSidebar} isSidebarOpen={isSidebarOpen} />
            {children}
          </div>
        </div>
      </AntdRegistry>
    </UserStoreProvider>
  )
}
